import React from 'react';
import { assets } from '../../helpers/assets';
import { useGS } from '../../hook/useGS';
import { isHTHCompany } from '../../helpers/utils';

const Logo: React.FC<
  React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = (props) => {
  const { snap: gsSnap } = useGS();
  const isHTH = isHTHCompany();
  return (
    <img
      alt='Logo'
      src={props.src || isHTH ? assets.logoHth2024 : gsSnap.companyLogoUrl || assets.logo}
      {...{ props, mini: undefined }}
      style={{ height: isHTH ? 46 : 44, ...props.style }}
    />
  );
};

export default Logo;
